export default {
  projectCalendarData: { calendarData: [], calendarSideList: [] },
  teamCalendarData: { calendarData: [], calendarSideList: [] },
};
